export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8670.027f3411.jpg";